import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { ATTACHMENT_API } from "./apiRoutes";

const mutateDeleteAttachment = async ({
  attachmentId,
}: {
  attachmentId: string;
}) => {
  return await axiosAuth.delete(`${ATTACHMENT_API}/${attachmentId}`);
};

const useDeleteAttachmentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      attachmentId: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteAttachment,
    ...queryParams,
  });

export default useDeleteAttachmentMutation;
